import React from 'react';
import AppGallery from './AppGallery';

const Index = () => {
  return (
        <AppGallery />
  );
};

export default Index;
